import { Dialog, DialogContent, DialogTitle } from "@/components/ui/dialog";
import CampaignStatusForm from "routes/campaign_status/components/CampaignStatusForm";

const HEADER = "Edit Campaign Status";

const EditCampaignStatusModal = ({
  campaignStatus,
  open,
  onOpenChange,
  fetchStatuses,
}) => {
  const handleSuccess = () => {
    onOpenChange(false);
    fetchStatuses();
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent>
        <DialogTitle>{HEADER}</DialogTitle>
        <CampaignStatusForm
          campaignStatus={campaignStatus}
          onSuccess={handleSuccess}
          submitButtonText="Save"
        />
      </DialogContent>
    </Dialog>
  );
};

export default EditCampaignStatusModal;
